import { useState } from 'react';
import Image from 'next/image';
import { useIntl } from 'react-intl';
import type { OrganizerMedia } from '@/types/organizer';
import { ShowMoreButton } from '../_shared/ShowMoreButton/ShowMoreButton';
import { MediaLightbox } from './MediaLightbox/MediaLightbox';
import { ViewExpandIcon } from './ViewExpandIcon';
import styles from './MediaGallery.module.scss';

const PAGE_SIZE = 12;

function getPageSize() {
  return PAGE_SIZE;
}

interface Props {
  medias: OrganizerMedia[];
}

export function MediaGallery({ medias }: Props) {
  const intl = useIntl();
  const pageSize = getPageSize();
  const [visibleCount, setVisibleCount] = useState(pageSize);
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);

  const visibleMedias = medias.slice(0, visibleCount);
  const hasMore = visibleCount < medias.length;

  return (
    <>
      <div className={styles.grid}>
        {visibleMedias.map((media, index) => (
          <button
            key={media.imageId}
            type="button"
            className={styles.tile}
            onClick={() => setLightboxIndex(index)}
            aria-label={intl.formatMessage(
              { id: 'View media {number}', defaultMessage: 'View media {number}' },
              { number: index + 1 },
            )}
          >
            <Image
              className={styles.tileImage}
              src={media.url}
              alt=""
              fill
              sizes="(max-width: 639px) 33vw, 25vw"
            />
            <div className={styles.tileOverlay}>
              <ViewExpandIcon className={styles.tileIcon} />
            </div>
          </button>
        ))}
      </div>

      {hasMore && (
        <div className={styles.showMore}>
          <ShowMoreButton
            onShowMore={() => setVisibleCount((c) => c + pageSize)}
            isLoadingMore={false}
          />
        </div>
      )}

      {lightboxIndex !== null && (
        <MediaLightbox
          medias={medias}
          activeIndex={lightboxIndex}
          onClose={() => setLightboxIndex(null)}
          onNavigate={setLightboxIndex}
        />
      )}
    </>
  );
}
